// Interfaces
import { getLocalFromUTC, getDateTimeTemplate } from './dateTime';
import { ISystemNotificationItem, ISystemNotificationMessage } from '../interfaces/notification.interfaces';
import { DateTimeFormat } from '../enums';

export function build90DaysReminderNotification(): ISystemNotificationItem {
    const notification: ISystemNotificationItem = {
        id: 1,
        activeFromDate: '',
        activeToDate: '',
        organizationId: 1,
        _expands: {
            messages: [
                {
                    id: 1,
                    systemNotificationId: 1,
                    languageId: 1,
                    subject: 'subject',
                    content: 'Make sure your contact information is correct',
                    fromDate: '',
                    toDate: '',
                },
                {
                    id: 2,
                    systemNotificationId: 1,
                    languageId: 2,
                    subject: 'subject',
                    content: 'Sørg for, at dine kontaktoplysninger er korrekte',
                    fromDate: '',
                    toDate: '',
                },
            ],
            acknowledges: [],
        },
    };
    return notification;
}

export const formatNotificationMessageDates = (message: ISystemNotificationMessage, language: string): string => {
    const localFromDate = message.fromDate
        ? getLocalFromUTC(message.fromDate, getDateTimeTemplate(DateTimeFormat.DATE_AND_TIME, language), language)
        : null;
    const localToDate = message.toDate
        ? getLocalFromUTC(message.toDate, getDateTimeTemplate(DateTimeFormat.DATE_AND_TIME, language), language)
        : null;
    let newMessage = message.content.replace('{fromDate}', localFromDate || '');
    newMessage = newMessage.replace('{toDate}', localToDate || '');
    return newMessage;
};

export const getLanguageSpecificMessage = (
    notification: ISystemNotificationItem,
    languageId: number
): ISystemNotificationMessage => {
    return notification._expands.messages.find((message) => {
        return message.systemNotificationId === notification.id && message.languageId === languageId;
    });
};
